import { gql } from '@apollo/client'

import { cartFragment, shopFragment } from '../fragments'

export const getShopQuery = gql`
  ${shopFragment}

  query getShop {
    shop {
      ...ShopFragment
    }
  }
`

export const getShopAndCartQuery = gql`
  ${shopFragment}
  ${cartFragment}

  query getShopAndCart($cartId: ID!) {
    shop {
      ...ShopFragment
    }
    cart(id: $cartId) {
      ...CartFragment
    }
  }
`
